export default __webpack_public_path__ + "static/media/diamond.814822ef.png";